// material-ui
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import MainCard from '../MainCard';

const DadosIniciais = ({
  color,
  title,
  count,
  percentage,
  isLoss,
  extra,
  textExtra1,
  textExtra2,
}) => (
  <MainCard contentSX={{ p: 2.25 }}>
    <Stack spacing={0.5}>
      <Typography variant="h6" color="textSecondary">
        {title}
      </Typography>
      <Grid container alignItems="center">
        <Grid item>
          <Typography variant="h4" color="inherit">
            {count}
          </Typography>
        </Grid>
        {percentage && (
          <Grid item>
            <Chip
              variant="combined"
              color={color}
              label={`${percentage}%`}
              sx={{ ml: 1.25, pl: 1 }}
              size="small"
            />
          </Grid>
        )}
      </Grid>
    </Stack>
    <Box sx={{ pt: 2.25 }}>
      {extra ? (
        <Typography variant="caption" color="textSecondary">
          {textExtra1}
          <Typography
            component="span"
            variant="caption"
            sx={{ color: `${color || 'primary'}.main` }}
          >
            {extra}
          </Typography>{' '}
          {textExtra2}
        </Typography>
      ) : (
        <>
          {' '}
          <Typography variant="caption" color="textSecondary">
            .
          </Typography>
        </>
      )}
    </Box>
  </MainCard>
);

export default DadosIniciais;
